<template>
  <div>
    <add-companies-group-component
      :companies-group-data-prop="companiesGroupDataComputed"
      :is-edit="isEdit" 
      v-if="companiesGroupDataComputed"/> 

  </div>
    
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import AddCompaniesGroupComponent from "../../components/AddCompaniesGroupComponent";

  export default {
    name: "Edit",
    components: {AddCompaniesGroupComponent},
    data() {
      return {
        isEdit: true,
      }
    },
    async created() {
      if(this.companies.length === 0){
        this.$vs.loading({ text: 'Loading Companies' })
        await this.loadAllCompanies({
            storeName: 'companies',
            url: `admin/companies`,
            commitUrl: 'companies/SET_COMPANIES',
        })
        this.$vs.loading.close()
      }

      this.$vs.loading({ text: 'Loading Group Details' })
      if (this.companiesGroups.length === 0) {
        await this.loadAllCompaniesGroups({
          storeName: 'companiesGroups',
          url: `admin/companiesGroups`,
          commitUrl: 'companiesGroups/SET_COMPANIES_GROUP',
        })
      }

      await this.loadCompaniesGroupItemFun()
      // console.log(this.companiesGroupData)
      this.$vs.loading.close()


    },
    computed: {
      ...mapGetters({
        companies: 'companies/companiesList',
        companiesGroups: 'companiesGroups/companiesGroupsList',
        companiesGroupData: 'companiesGroups/editItem',
        isLoading: 'companiesGroups/isLoading',
        error: 'companiesGroups/error',
      }),
      companiesGroupDataComputed() {
        return this.companiesGroupData
      },
    },
    methods: {
      ...mapActions({
        loadAllCompaniesGroups: 'get',
        loadAllCompanies: 'get',      
        loadItem: 'getLocalItem',
      }),
      loadCompaniesGroupItemFun() {
        this.loadItem({
          commitUrl: 'companiesGroups/GET_COMPANIES_GROUP',
          id: this.$route.params.companiesGroupID
        })
      }
    }
  }
</script>
